import {getCurrentInstance} from 'vue'

type G = Record<string, any>

export default function (): G {
  return getCurrentInstance()?.appContext?.config.globalProperties as G
}
